module.exports = __webpack_public_path__ + "img/145ne.305d9417.svg";